import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { GeneralResponse } from "../../../types/api";
import { Methods } from "../../constants/CommonConstants";
import { handleApiResponseErrors } from "../HandleAPIResponseErrors";
import Api from "../axios";
import { EndPoints } from "../endPoints";
import { IResendCodeRequest } from "../../../types/apis/auth-apis";

export const ResendOTPCode = async (
  payload: IResendCodeRequest,
): Promise<GeneralResponse> => {
  try {
    const response = await Api<any, GeneralResponse<IResendCodeRequest>>({
      method: Methods.POST,
      endpoint: EndPoints.resendCode,
      body: payload,
    });
    handleApiResponseErrors(response, "validation_error");
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const useResendOTP = (options = {}) => {
  const mutation: UseMutationResult<
    GeneralResponse,
    Error,
    IResendCodeRequest
  > = useMutation({
    mutationFn: ResendOTPCode,
    ...options,
  });

  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
